import { GroupTranslation } from '@d-id/types';
import styled from '@emotion/styled';
import TranslationListItem from './TranslationListItem';

const List = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    max-height: 17rem;
    overflow-y: auto;
`;

const Buffer = styled.div`
    width: 100%;
    height: 7.6rem;
`;

interface IProps {
    translations: GroupTranslation[];
}

function TranslationList({ translations }: IProps) {
    return (
        <>
            <List>
                {translations.map(translation => (
                    <TranslationListItem translation={translation} />
                ))}
            </List>
            <Buffer />
        </>
    );
}

export default TranslationList;
